<template>
    <div class="unassigned-card d-flex">
        <FindNearbyEmployees
            v-if="show"
            :selectedPatientVisit="patientVisitDetails"
            :patientInfoWindowContent="patientInfoWindow"
            :date="visitDate"
            :isUnassigned="closeUnassignedMap"
        />
    </div>
</template>

<style src="./UnassignedPatientVisitsMap.scss"></style>
<script src="./UnassignedPatientVisitsMap.ts"></script>
